import { connect } from "react-redux";

import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";

import { VisibilityWrapper } from "./VisibilityWrapper";

interface VisibilityWrapperContainerProps {
    bindingPath: AbsoluteModelPath;
    pathValue?: string;
    inversion: boolean;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: VisibilityWrapperContainerProps) => {
    const { bindingPath, inversion, pathValue, viewModelSelect } = ownProps;
    const controlModel = viewModelSelect.controlModel(state, bindingPath);

    if (pathValue != undefined) {
        const valueEqualPathValue = String(controlModel.value) === pathValue;
        return {
            visible: inversion ? !valueEqualPathValue : valueEqualPathValue,
        };
    }
    const visible = controlModel.visible ?? false;
    return {
        visible: inversion ? !visible : visible,
    };
};

export const VisibilityWrapperContainer = withResolvePaths(
    withViewModelSelect(connect(mapStateToProps)(VisibilityWrapper))
);
